import { cx } from './cx'

/** A Figma-exported icon at its exact frame size (12 or 16px). Decorative unless `label` is set. */
export function Icon({ src, size, label, className }: { src: string; size: 12 | 16; label?: string; className?: string }) {
    return (
        <img
            src={src}
            width={size}
            height={size}
            alt={label ?? ''}
            aria-hidden={label ? undefined : true}
            className={cx('block shrink-0', size === 12 ? 'size-[12px]' : 'size-[16px]', className)}
        />
    )
}
